import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import '../css/PrivacyPage.css';
import '../css/WarrantyPage.css';
import '../css/PaymentPage.css';

const PaymentPage = () => {
    return (
        <Layout>
            <SEO
                title="Оплата та доставка — Union Auto"
                description="Способи оплати та доставки в інтернет-магазині Union Auto. Нова пошта по всій Україні. Накладений платіж та оплата на рахунок ФОП."
                canonical="/payment"
            />
            <div className="privacy-page warranty-page">

                <header className="privacy-header">
                    <h1 className="privacy-title">Оплата та доставка</h1>
                    <p className="privacy-date">Доставка по всій Україні · Нова пошта</p>
                </header>

                {/* Доставка */}
                <section className="privacy-section">
                    <h2>Доставка по Україні</h2>
                    <p>
                        Ми здійснюємо доставку замовлень по всій території України, за винятком тимчасово
                        окупованих територій та регіонів, де доставка обмежена або неможлива через обставини,
                        що не залежать від магазину.
                    </p>

                    <div className="pd-service-cards">
                        <div className="pd-service-card">
                            <span className="pd-service-card__icon">🏢</span>
                            <span>Нова пошта</span>
                            <span className="pd-service-card__sub">відділення</span>
                            <span className="pd-service-card__price">від 80 грн.</span>
                        </div>
                        <div className="pd-service-card">
                            <span className="pd-service-card__icon">📦</span>
                            <span>Нова пошта</span>
                            <span className="pd-service-card__sub">поштомат</span>
                            <span className="pd-service-card__price">від 90 грн.</span>
                        </div>
                        <div className="pd-service-card">
                            <span className="pd-service-card__icon">🚗</span>
                            <span>Нова пошта</span>
                            <span className="pd-service-card__sub">кур'єрська доставка</span>
                            <span className="pd-service-card__price">від 105 грн.</span>
                        </div>
                    </div>

                    <p style={{ marginTop: 4 }}>
                        Остаточна вартість визначається перевізником і залежить від ваги та габаритів
                        посилки, способу доставки та місця призначення.
                    </p>
                </section>

                {/* Терміни */}
                <section className="privacy-section">
                    <h2>Терміни доставки</h2>
                    <p>
                        Більшість замовлень доставляються протягом <strong>1–3 робочих днів</strong> після надсилання.
                    </p>
                    <p>
                        У періоди підвищеного навантаження, святкових днів, форс-мажорних обставин або затримок
                        з боку перевізника термін доставки може бути збільшений. Магазин не несе
                        відповідальності за затримки, спричинені роботою служб доставки.
                    </p>
                </section>

                {/* Надсилання */}
                <section className="privacy-section">
                    <h2>Надсилання замовлень</h2>
                    <div className="pd-dispatch-grid">
                        <div className="pd-dispatch-item">
                            <span className="pd-dispatch-item__time">до 15:00</span>
                            <span className="pd-dispatch-item__label">у робочі дні</span>
                            <span className="pd-dispatch-item__result">Надсилання того ж дня</span>
                        </div>
                        <div className="pd-dispatch-item">
                            <span className="pd-dispatch-item__time">після 15:00</span>
                            <span className="pd-dispatch-item__label">або вихідні/свята</span>
                            <span className="pd-dispatch-item__result">Надсилання наступного робочого дня</span>
                        </div>
                    </div>
                    <p>
                        Після надсилання покупець отримує <strong>номер транспортної накладної (ТТН)</strong> для
                        відстеження посилки.
                    </p>
                    <p>
                        Магазин залишає за собою право додатково підтвердити замовлення по телефону перед
                        його відправкою.
                    </p>
                </section>

                {/* Оплата */}
                <section className="privacy-section">
                    <h2>Способи оплати</h2>

                    <div className="pd-payment-cards">
                        <div className="pd-payment-card">
                            <div className="pd-payment-card__header">
                                <span className="pd-payment-card__num">1</span>
                                <span className="pd-payment-card__title">Накладений платіж</span>
                                <span className="pd-payment-card__badge">Післяплата</span>
                            </div>
                            <ul>
                                <li>Оплата при отриманні товару у відділенні перевізника</li>
                                <li>Можливість огляду товару до оплати</li>
                                <li>Комісія за переказ коштів — за тарифами Нової пошти</li>
                            </ul>
                            <div className="warranty-note" style={{ marginTop: 12 }}>
                                Комісія Нової пошти: 2% від суми переказу + 20 грн. Тарифи може бути
                                змінено перевізником самостійно.
                            </div>
                        </div>

                        <div className="pd-payment-card">
                            <div className="pd-payment-card__header">
                                <span className="pd-payment-card__num">2</span>
                                <span className="pd-payment-card__title">Онлайн-оплата</span>
                                <span className="pd-payment-card__badge pd-payment-card__badge--green">Без комісії</span>
                            </div>
                            <ul>
                                <li>Банківський переказ за реквізитами IBAN на рахунок ФОП</li>
                                <li>Без додаткової комісії з боку магазину</li>
                            </ul>
                            <div className="pd-bank-details">
                                <div className="pd-bank-details__row">
                                    <span className="pd-bank-details__label">Отримувач</span>
                                    <span className="pd-bank-details__value">ФОП Фігура Тетяна Богданівна</span>
                                </div>
                                <div className="pd-bank-details__row">
                                    <span className="pd-bank-details__label">ЄДРПОУ</span>
                                    <span className="pd-bank-details__value">2586412525</span>
                                </div>
                                <div className="pd-bank-details__row">
                                    <span className="pd-bank-details__label">IBAN</span>
                                    <span className="pd-bank-details__value pd-bank-details__value--mono">UA493052990000026009041032053</span>
                                </div>
                                <div className="pd-bank-details__row">
                                    <span className="pd-bank-details__label">Банк</span>
                                    <span className="pd-bank-details__value">АТ КБ «ПРИВАТБАНК»</span>
                                </div>
                                <div className="pd-bank-details__row">
                                    <span className="pd-bank-details__label">МФО</span>
                                    <span className="pd-bank-details__value">305299</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

                {/* Перевірка при отриманні */}
                <section className="privacy-section">
                    <h2>Перевірка товару при отриманні</h2>
                    <p>
                        Покупець має право оглянути товар при отриманні, перевірити комплектність та
                        відсутність видимих пошкоджень.
                    </p>
                    <p>
                        У разі виявлення пошкоджень, некомплектності або невідповідності замовлення
                        рекомендується відмовитися від отримання відправки та негайно повідомити менеджера
                        магазину.
                    </p>
                </section>

                {/* Важлива інформація */}
                <section className="privacy-section">
                    <h2>Важлива інформація</h2>
                    <ul>
                        <li>Фактичні терміни доставки залежать від роботи служби доставки.</li>
                        <li>Оформлення замовлення означає згоду Покупця на умови доставки та оплати, викладені на цій сторінці.</li>
                    </ul>
                </section>

            </div>
        </Layout>
    );
};

export default PaymentPage;
